import React, {useEffect, useState} from "react";
import Container from "@mui/material/Container";
import {Head, Loading} from "../../components";
import {Box, Tooltip} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import ReactPaginate from "react-paginate";
import IconButton from "@mui/material/IconButton";
import SyncIcon from "@mui/icons-material/Sync";
import moment from "moment-jalaali";
import Api from "../../utils/api";
import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import queryString from 'query-string';

const CommissionPeriod = () => {

    const history = useNavigate();
    const location = useLocation();

    const query = queryString.parse(location.search);
    const [params, setParams] = useState({
        page: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 100,
        status:query.status ? parseInt(query.status) : 0,
        parent_id: query.parent_id ? parseInt(query.parent_id) : '',
        name: query.name ? query.name : '',
        username:query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        mobile: query.mobile ? query.mobile : '',
    });
    const [loading, setLoading] = useState(true);
    const [commissionPeriod, setCommissionPeriod] = useState([]);
    const [ShowImg, setShowImg] = useState(false);
    const [img, setImg] = useState('')





    const handleCommissionPeriod = () => {
        new Api().get('/marketers/contract/commission/calculate', {
            "form": "commission_calculate",
            "period_id": 78
        }).then((response) => {
            if (typeof response !== "undefined") {
                setCommissionPeriod(response);
            }

            setLoading(false);
        })
    }

    useEffect(() => {
        handleCommissionPeriod()
    } ,[])

    useEffect(() => {


        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, []);






    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = value;
                break;
        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;

        history(`/marketer/contract/commission/period/${url}`);

    };

    const pageCount = Math.ceil(parseInt(commissionPeriod?.details?.list?.total) / parseInt(commissionPeriod?.details?.list?.per_page));


    return(
        <Container>
            <Head data={{ 'link': '/', 'title': ' کمیسیون ها', 'description': `کل کمیسیون دوره : ${ commissionPeriod?.details?.period_commission}`}} />

            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <Tooltip title="سینک" onClick={() => handleCommissionPeriod()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>آی دی بازاریابی</th>
                        <th>کد بازاریابی</th>
                        <th>کمیسون</th>
                        <th>تاریخ به روزرسانی</th>
                    </tr>
                    </thead>
                    <tbody>
                    {commissionPeriod?.details?.marketers_commission?.data?.map((item, index) => {
                        return(
                            <tr>
                                <td>{index + 1}</td>
                                <td>{item.id || "---"}</td>
                                <td>{item?.marketer_code || "---"}</td>
                                <td>{item.commission || "---"}</td>
                                <td style={{ direction: 'ltr'}}>{moment(item.updated_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
            <Dialog
                open={ShowImg}
                onClose={() => setShowImg(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <img style={{ borderRadius: 0, maxHeight: 300}} src={img}/>
            </Dialog>
        </Container>
    );

}

export default CommissionPeriod;